@if ({ links: links(), tabPanel: tabPanel() }; as STATE) {
  <page class="configuration-page-layout">
    <page-header [enableDateRangeFilter]="false"></page-header>
    <nav
      *ngxPermissionsOnly="[
        permission.READ_DGI_DASHBOARD_CONFIG,
        permission.READ_DGI_SECURITY_CONFIG
      ]"
      mat-tab-nav-bar
      [mat-stretch-tabs]="false"
      animationDuration="0ms"
      aria-label="Navigation des configurationes"
      [tabPanel]="STATE.tabPanel"
    >
      <a
        *ngFor="let link of STATE.links"
        mat-tab-link
        [routerLink]="link.path"
        routerLinkActive
        #rla="routerLinkActive"
        [active]="rla.isActive"
        [attr.aria-current]="rla.isActive ? 'page' : null"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <mat-icon
          *ngIf="link.icon"
          [svgIcon]="'dgi-' + link.icon"
          aria-hidden="true"
        ></mat-icon>
        {{ link.title }}
      </a>
    </nav>
    <mat-tab-nav-panel #tabPanel>
      <router-outlet></router-outlet>
    </mat-tab-nav-panel>
  </page>
}
